module.exports = __webpack_public_path__ + "static/img/4-1-3.aa9f35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-1-3.png
// module id = jvKp
// module chunks = 12